import Vue from 'vue'
import VueLogger from 'vuejs-logger'
import App from '@/app.vue'
import router from '@/router'
import vuetify from '@/plugins/vuetify';
import store from '@/store'

Vue.config.productionTip = false

const development = process.env.NODE_ENV !== 'production'
 
const options = {
    isEnabled: development,
    logLevel : 'debug',
    stringifyArguments : false,
    showLogLevel : true,
    showMethodName : true,
    separator: '|',
    showConsoleColors: true
}
 
Vue.use(VueLogger, options)

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app')
